module.exports = {
	"😂": 1,
	"❤": 3,
	"♥": 3,
	"😍": 3,
	"😭": -1,
	"😘": 3,
	"😊": 3,
	"👌": 2,
	"💕": 3,
	"👏": 2,
	"😁": 2,
	"☺": 3,
	"♡": 3,
	"👍": 2,
	"😩": -2,
	"🙏": 2,
	"✌": 2,
	"😏": 1,
	"😉": 2,
	"🙌": 2,
	"🙈": 2,
	"💪": 2,
	"😄": 2,
	"😒": -2,
	"💃": 3,
	"💖": 3,
	"😃": 2,
	"😔": -1,
	"🎉": 3,
	"😜": 2,
	"🌸": 3,
	"💜": 3,
	"💙": 3,
	"✨": 1,
	"💗": 3,
	"★": 1,
	"█": -1,
	"☀": 2,
	"😡": -1,
	"😎": 2,
	"💋": 3,
	"😋": 3,
	"🙊": 2,
	"😴": -1,
	"🎶": 2,
	"💞": 3,
	"😌": 2,
	"🔫": -1,
	"💛": 3,
	"💁": 1,
	"💚": 3,
	"♫": 1,
	"😞": -1,
	"😆": 2,
	"😝": 2,
	"😪": -1,
	"😫": -1,
	"👊": 1,
	"💀": -2,
	"😀": 2,
	"😚": 3,
	"😻": 3,
	"💘": 3,
	"☕": 1,
	"👋": 2,
	"🎊": 3,
	"🍕": 2,
	"❄": 2,
	"😕": -2,
	"💔": -1,
	"😤": -2,
	"😈": 1,
	"✈": 2,
	"🔝": 2,
	"😰": -1,
	"⚽": 3,
	"😑": -2,
	"👑": 3,
	"👉": 1,
	"🍃": 1,
	"🎁": 3,
	"😠": -2,
	"🐧": 2,
	"☆": 2,
	"🍀": 1,
	"🎈": 3,
	"🎅": 1,
	"😓": -1,
	"😣": -2,
	"😐": -2,
	"✊": 2,
	"😨": -1,
	"😖": -1,
	"💤": 1,
	"💓": 3,
	"👎": -1,
	"💦": 2,
	"✔": 1,
	"😷": -1,
	"🙋": 2,
	"🎄": 2,
	"💩": -1,
	"🎵": 2,
	"😛": 3,
	"👯": 2,
	"💎": 2,
	"🌿": 1,
	"🎂": 3,
	"🌟": 1,
	"🔮": 1,
	"👫": 1,
	"🏆": 3,
	"✖": 1,
	"☝": 1,
	"😙": 3,
	"⛄": 2,
	"👅": 2,
	"♪": 2,
	"🍂": 2,
	"💏": 1,
	"🌴": 2,
	"👈": 2,
	"🌹": 3,
	"🙆": 2,
	"👻": 1,
	"💰": 1,
	"🍻": 2,
	"🙅": -2,
	"🌞": 2,
	"🍁": 2,
	"⭐": 2,
	"▪": 1,
	"🎀": 3,
	"🐷": 1,
	"🙉": 1,
	"🌺": 2,
	"💅": 1,
	"🐶": 2,
	"🌚": 2,
	"👽": 1,
	"🎤": 2,
	"👭": 2,
	"🎧": 2,
	"👆": 1,
	"🍸": 2,
	"🍷": 2,
	"®": 1,
	"🍉": 3,
	"😇": 3,
	"🏃": 2,
	"😿": -2,
	"│": 1,
	"🍺": 2,
	"▶": 1,
	"😲": -1,
	"🎸": 2,
	"🍹": 3,
	"💫": 2,
	"📚": 1,
	"😶": -1,
	"🌷": 2,
	"💝": 3,
	"💨": 1,
	"🏈": 2,
	"💍": 2,
	"☔": 1,
	"👸": 3,
	"🇪": 3,
	"░": -1,
	"🍩": 1,
	"👾": 1,
	"☁": 1,
	"🌻": 2,
	"↿": 3,
	"🐯": 2,
	"👼": 1,
	"🍔": 1,
	"😸": 2,
	"👶": 2,
	"↾": 3,
	"💐": 3,
	"🌊": 2,
	"🍦": 2,
	"🍓": 3,
	"👇": 1,
	"💆": 1,
	"🍴": 2,
	"😧": -1,
	"🇸": 2,
	"😮": 1,
	"🚫": -3,
	"😽": 2,
	"🌈": 2,
	"🙀": 1,
	"⚠": -1,
	"🎮": 2,
	"╯": -1,
	"🍆": 2,
	"🍰": 2,
	"✓": 1,
	"👐": -1,
	"🍟": 1,
	"🍌": 2,
	"💑": 3,
	"👬": -1,
	"🐣": 2,
	"🎃": 3,
	"▬": 2,
	"￼": -3,
	"🐾": 3,
	"🎓": 2,
	"🏊": 2,
	"📷": 2,
	"👄": 2,
	"🌼": 4,
	"🚶": -1,
	"🐱": 2,
	"🐸": -1,
	"🇺": 2,
	"👿": -3,
	"🚬": 2,
	"✿": 1,
	"🐒": 2,
	"🌍": 3,
	"┊": 5,
	"🐥": 3,
	"🐼": 1,
	"🎥": 1,
	"💄": 2,
	"⛔": 2,
	"🏀": 1,
	"💉": 1,
	"💟": 3,
	"🚗": 1,
	"📝": 1,
	"♦": 2,
	"💭": 1,
	"🌙": 3,
	"🐟": 3,
	"👣": 1,
	"✂": -3,
	"🗿": 2,
	"👪": -1,
	"🍭": 1,
	"🌃": 2,
	"❌": 1,
	"🐰": 3,
	"💊": 2,
	"🚨": 3,
	"😦": -2,
	"🍪": 1,
	"🍣": -2,
	"✧": 1,
	"🎆": 3,
	"🎎": 4,
	"🇩": 3,
	"✅": 2,
	"📱": 1,
	"🙍": -2,
	"🍑": 1,
	"🎼": 1,
	"🔊": 2,
	"🌌": 2,
	"🍎": 1,
	"🐻": 2,
	"╰": -1,
	"💇": 1,
	"♬": 1,
	"🔴": 2,
	"🍱": -2,
	"🍊": 2,
	"🍒": 1,
	"🐭": 3,
	"👟": 2,
	"🌎": 1,
	"🍍": 2,
	"🐮": 3,
	"📲": 1,
	"☼": 1,
	"🌅": 1,
	"🇷": 3,
	"👠": 1,
	"🌽": 2,
	"💧": -1,
	"🍬": 1,
	"😺": 2,
	"🚀": 2,
	"¦": 3,
	"💢": 1,
	"🎬": 1,
	"🍧": 1,
	"🍜": 2,
	"🐏": 3,
	"🏄": 2,
	"➤": 1,
	"⬆": 1,
	"🍋": 1,
	"🆗": 2,
	"⚪": 2,
	"📺": 2,
	"🍅": 1,
	"⛅": 2,
	"🐢": 1,
	"👙": 2,
	"🏡": 2,
	"🌾": 2,
	"◉": 1,
	"✏": 1,
	"🐬": 2,
	"🇹": 3,
	"♣": 1,
	"🐝": 1,
	"🌝": 1,
	"🇮": 3,
	"🔋": -3,
	"🐍": 1,
	"♔": 2,
	"🔵": 1,
	"😾": -2,
	"🌕": 3,
	"🐨": 2,
	"🔐": 1,
	"💿": 3,
	"🌳": 2,
	"👰": 2,
	"❀": 2,
	"⚓": 3,
	"🚴": 3,
	"▀": -1,
	"👗": 1,
	"➕": 2,
	"💬": 2,
	"▒": -1,
	"🔜": 1,
	"🍨": 1,
	"💲": 1,
	"🍙": 1,
	"🍥": -4,
	"▸": 1,
	"♛": 1,
	"😼": 1,
	"🐙": 2,
	"👨": 2,
	"🍚": 2,
	"♨": 4,
	"🎹": 1,
	"♕": 2,
	"▃": 5,
	"🇬": 1,
	"🇧": 1,
	"☠": -1,
	"🐠": 2,
	"🚹": 3,
	"💵": 2,
	"✰": 4,
	"╠": 1,
	"👛": 2,
	"🌱": 3,
	"💻": 1,
	"🌏": 1,
	"▄": -1,
	"👓": 1,
	"◄": 1,
	"⚾": -1,
	"🌲": 2,
	"👴": 1,
	"🏠": 2,
	"🍇": 1,
	"🍘": 2,
	"🐇": 1,
	"🔞": -1,
	"👵": 2,
	"◀": 1,
	"🔙": 1,
	"🌵": 1,
	"🍮": -1,
	"🎇": 3,
	"🐎": 2,
	"➔": -1,
	"🐤": 2,
	"╩": 1,
	"🌑": 2,
	"🚲": 2,
	"🐑": -1,
	"🏁": 2,
	"🎾": 3,
	"╚": 1,
	"🈹": 1,
	"👮": -2,
	"☹": -3,
	"🐵": 2,
	"✪": 1,
	"◕": 2,
	"🗼": 3,
	"▐": -1,
	"♠": 1,
	"┳": -2,
	"👺": -2,
	"🐚": 1,
	"👂": -1,
	"🗽": 1,
	"🍵": 2,
	"🆒": 2,
	"🐺": 1,
	"⇨": 2,
	"🌓": 3,
	"🔒": 1,
	"╬": -1,
	"👳": 3,
	"🌂": 1,
	"🚌": 1,
	"♩": 3,
	"🍡": -1,
	"❥": 1,
	"🎡": 1,
	"💌": 2,
	"🐩": 2,
	"🌜": 2,
	"⌚": 1,
	"🚿": 3,
	"🔆": 3,
	"🌛": 3,
	"💂": -1,
	"🐔": 1,
	"🙎": -1,
	"🏩": 2,
	"🇫": 2,
	"🔨": -1,
	"📢": 2,
	"🐦": 2,
	"🐲": -1,
	"♻": 2,
	"🌘": 3,
	"🌔": 3,
	"👖": 2,
	"😗": 3,
	"🐄": 1,
	"◟": -1,
	"🍢": -1,
	"🎨": 1,
	"⬇": 2,
	"🚼": 3,
	"🇴": 2,
	"🌗": 3,
	"🌖": 3,
	"🔅": 5,
	"👜": 1,
	"🐌": 3,
	"💼": 3,
	"🐹": 1,
	"🌠": 3,
	"🐈": 1,
	"🌁": 1,
	"⚫": 1,
	"♧": 2,
	"🏰": 1,
	"🚵": 2,
	"🎢": 2,
	"🎷": 3,
	"🎐": 1,
	"┈": -4,
	"╗": 2,
	"🌇": 3,
	"⏰": 2,
	"🚂": 1,
	"◠": 2,
	"🎿": 2,
	"🆔": 4,
	"🌒": 3,
	"🐪": 3,
	"╔": 1,
	"╝": 2,
	"👔": 2,
	"🆓": 1,
	"🐋": 1,
	"▽": 2,
	"🐛": 1,
	"👕": 2,
	"💳": 2,
	"🏧": 5,
	"💡": 3,
	"⬅": 2,
	"🐫": 2,
	"🇱": 2,
	"📹": 2,
	"👞": 2,
	"👚": 3,
	"□": -2,
	"🚣": 3,
	"🏉": 3,
	"🗻": 3,
	"╦": 2,
	"⛺": 3,
	"🐕": 1,
	"🏂": 2,
	"👡": 2,
	"📻": 2,
	"✒": 1,
	"🌰": 3,
	"🏢": 1,
	"🎒": 3,
	"⌒": 3,
	"🏫": -2,
	"📴": 4,
	"🚢": 1,
	"🚚": -1,
	"🐉": 1,
	"❒": 1,
	"🔔": 5,
	"◢": 4,
	"🏥": 1,
	"🚖": -1,
	"▌": -2,
	"☛": 2,
	"💒": 3,
	"🚤": 2,
	"🐐": 2,
	"■": -2,
	"🔚": 2,
	"🎻": 2,
	"🔷": 1,
	"🎽": 2,
	"📅": 1,
	"🎺": 3,
	"🍈": -3,
	"✉": 1,
	"◤": 5,
	"○": 3,
	"🍼": 3,
	"🚛": -2,
	"📓": 1,
	"☉": 1,
	"💴": -2,
	"➰": -1,
	"🔌": -1,
	"📕": 1,
	"📣": 2,
	"🚓": 1,
	"🐗": 3,
	"⛳": 4,
	"┻": -3,
	"┛": 3,
	"┃": 2,
	"💺": 1,
	"🏇": -1,
	"☻": 1,
	"📞": 2,
	"Ⓐ": -1,
	"🌉": 3,
	"🚩": -2,
	"✎": 3,
	"📃": 2,
	"🏨": 1,
	"📌": -3,
	"♎": -1,
	"💷": 2,
	"🚄": 3,
	"▲": 3,
	"⛵": 3,
	"🔸": 1,
	"🚜": 5,
	"🐆": 2,
	"👒": 1,
	"❕": 1,
	"🔛": 2,
	"♢": 2,
	"🇲": 2,
	"❅": 4,
	"👝": 2,
	"✞": 2,
	"◡": 1,
	"🎋": 3,
	"👥": 1,
	"🐡": 1,
	"◆": 4,
	"🔭": 2,
	"🎪": 1,
	"🐜": 3,
	"♌": 4,
	"☐": -5,
	"👷": 1,
	"🔈": 1,
	"📄": 5,
	"🚐": 4,
	"🌋": 3,
	"📡": 1,
	"🚳": 5,
	"✘": 4,
	"🅰": 1,
	"🇼": 2,
	"┓": 3,
	"┣": 3,
	"Ⓛ": 2,
	"Ⓔ": 2,
	"👤": 4,
	"🚁": 1,
	"🎠": 3,
	"🐁": -2,
	"📗": 1,
	"┐": -1,
	"♂": 1,
	"📯": -1,
	"🔩": 1,
	"👢": 4,
	"◂": 2,
	"📰": 1,
	"📶": 2,
	"🌄": 1,
	"🗾": 2,
	"🔶": 2,
	"🏤": 2,
	"🎩": 2,
	"Ⓜ": 1,
	"🔧": -4,
	"🐅": 1,
	"♮": 1,
	"🅾": -1,
	"📦": 1,
	"🚊": 1,
	"🔲": 3,
	"△": 1,
	"📆": 5,
	"❛": 2,
	"📉": 2,
	"▵": 2,
	"🔎": 3,
	"☜": 1,
	"🇯": 2,
	"🇵": 2,
	"📘": 1,
	"ⓔ": 3,
	"🔑": 1,
	"⭕": 2,
	"🔘": 1,
	"🚭": 5,
	"🚉": 3,
	"🚪": 3,
	"➳": 2,
	"🚃": 3,
	"┯": -3,
	"🆙": 2,
	"🆖": 1,
	"┗": 5,
	"Ⓞ": 2,
	"❇": 3,
	"✴": 3,
	"☊": 5,
	"🔕": -2,
	"⬛": -2,
	"🚞": 3,
	"🍶": 3,
	"🌐": 3,
	"♀": 1,
	"🚅": 3,
	"🚒": -2,
	"♋": 1,
	"♍": 3,
	"🕝": -2,
	"ⓐ": 5,
	"📙": 1,
	"Ⓢ": 1,
	"📋": 3,
	"🎱": 1,
	"🐞": 1,
	"🔺": 1,
	"ⓡ": 5,
	"♤": 3,
	"🎯": 3,
	"🔉": 3,
	"↩": 5,
	"🚾": 1,
	"🎣": -4,
	"🔣": 1,
	"❎": -5,
	"➥": 1,
	"🎌": 5,
	"◣": 1,
	"⏬": 5,
	"♭": 1,
	"ⓞ": 5,
	"🔳": 2,
	"🏭": 2,
	"🎳": -3,
	"☚": 5,
	"➽": 2,
	"➫": 2,
	"➖": -5,
	"꒰": 2,
	"꒱": 2,
	"◝": -3,
	"📑": 5,
	"ⓧ": 5,
	"🔟": 5,
	"〓": 5,
	"ⓜ": 2,
	"➠": 5,
	"🚆": 2,
	"℅": -5,
	"☃": 2,
	"🚽": 5,
	"ⓝ": 5,
	"⇦": 5,
	"👲": 2,
	"🚡": -3,
	"🔬": 5,
	"➗": -3,
	"📈": 2,
	"⏪": 2,
	"◎": 5,
	"꒦": -5,
	"📎": 5,
	"⑅": 5,
	"✭": 5,
	"♓": 2,
	"┏": 5,
	"☇": 5,
	"࿎": -5,
	"👘": 5,
	"↙": 5,
	"Ⓕ": 2,
	"Ⓦ": 2,
	"Ⓟ": 2,
	"🕑": 2,
	"🕛": 5,
	"♈": -5,
	"↬": 5,
	"✍": 5,
	"🏦": 5,
	"🔻": 5,
	"ⓟ": 5,
	"ⓕ": 5,
	"ⓘ": 5,
	"♿": 5,
	"⇗": 5,
	"⇘": 5,
	"ⓨ": 5,
	"ⓙ": 5,
	"▫": 5,
	"🔇": 5,
	"⌃": -5,
	"🔖": 5,
	"📜": 5,
	"🚝": 5,
	"┘": -5,
	"✝": -5,
	"⍣": -5,
	"📮": -5,
	"🕕": -5,
	"🔯": 5,
	"➸": 5,
	"꒵": 5,
	"🕥": -5,
	"✽": 5,
	"📼": 5,
	"🕐": -5,
	"🀄": 5,
	"✬": 5,
	"✫": 5,
	"🕔": -5,
	"❣": 5,
	"📫": 5,
	"🉐": 5,
	"🈂": -5,
	"🎰": -5,
	"҂": -5,
	"╤": -5,
	"📔": 5
};


//////////////////
// WEBPACK FOOTER
// ./~/sentiment/build/emoji.json
// module id = 2295
// module chunks = 0